// TODO: replace all static routes in the code with this enum
export enum AppRoutes {
  DUMMY = "/dummy",
  RESET_PASSWORD = "/reset_password/:token",
  CREATE_PASSWORD = "/create-password/:token",
  HOME = "/",
  SIGN_UP_RBO = "/signup-rbo",
  VERIFY_EMAIL = "/verify_email/:token",
  VERIFY_PROFILE = "/verify-profile",
  LISTING_MANAGEMENT = "/listing-management",
  LISTING_DETAILS_LOCATION = "/listing-details/:propertyId/location-details",
  LISTING_DETAILS_PRICING = "/listing-details/:propertyId/pricing",
  LISTING_DETAILS_AVAILABILITY = "/listing-details/:propertyId/availability",
  LISTING_DETAILS_PDP = "/listing-details/:propertyId/pdp",
  LISTING_DETAILS_CANCELLATION_POLICY = "/listing-details/:propertyId/cancellation-policy",
  LISTING_DETAILS_MINIMUM_AGE = "/listing-details/:propertyId/minimum-age-requirement",
  LISTING_DETAILS_CALENDAR_SYNC = "/listing-details/:propertyId/calendar-sync",
  LISTING_DETAILS_CONGRATULATIONS = "/listing-details/:propertyId/congratulations",
  LISTING_DETAILS_ADD_VIDEO = "/listing-details/:propertyId/add-video-to-your-listing",
  REVIEW_PUBLISH_LISTING = "/listing-details/review-publish-listing",
  MESSAGES = "/messages",
  REVIEWS = "/reviews",
  MANAGE_QUICK_REPLIES = "/manage-quick-replies",
  SCHEDULED_MESSAGES = "/scheduled-messages",
  PROFILE_DETAILS = "/profile-details",
  PAYOUT_SETTINGS = "/payout-settings",
  EARNING_PROGRESS = "/earning-progress",
  RESERVATIONS = "/reservations",
  PAYOUT = "/payout",
  PAID_OUT_EXPECTED_REPORT = "/earning-progress/paid-out-expected-report",
}
